var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 2.9h8.45a2 2 0 0 1 2 2v14.2a2 2 0 0 1-2 2H8.2a2 2 0 0 1-2-2v-2.7a1 1 0 0 1 2 0v2.7h8.45V4.9H8.2v2.7a1 1 0 0 1-2 0V4.9a2 2 0 0 1 2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.22 11.36 3.03-3.03a.88.88 0 0 1 1.24 1.24L4.06 11h7.39a1 1 0 0 1 0 2H4.06l1.43 1.43a.88.88 0 1 1-1.24 1.24l-3.03-3.03a.9.9 0 0 1 0-1.28"
  })));
};
export default SvgLogout;